import managerService from '@/api/manager'
import { MANAGER_SET } from '../types'

export default {
  namespaced: true,
  state: {
    managers: []
  },
  mutations: {
    [MANAGER_SET] (state, managers) {
      state.managers = state.managers.push(managers)
    }
  },
  actions: {
    getManagers: function ({commit}) {
      return new Promise((resolve, reject) => {
        managerService.getManagers().then((response) => {
          commit(MANAGER_SET, response.data)
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    addManager: function ({state, dispatch}, manager) {
      let newManagers = [...state.managers]
      newManagers.push(manager)
      return dispatch('saveManagers', newManagers)
    },
    removeManager: function ({state, dispatch}, manager) {
      let newManagers = [...state.managers]
      newManagers = newManagers.filter((item) => {
        return item !== manager
      })
      return dispatch('saveManagers', newManagers)
    },
    saveManagers: function ({ dispatch }, managers) {
      managers = managers.slice(1)
      return new Promise((resolve, reject) => {
        managerService.saveManagers(managers).then(() => {
          dispatch('getManagers')
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    }
  }
}
